import { render, staticRenderFns } from "./UpgradeSubscriptionPage.vue?vue&type=template&id=3db37a1e&scoped=true&"
import script from "./UpgradeSubscriptionPage.vue?vue&type=script&lang=ts&"
export * from "./UpgradeSubscriptionPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db37a1e",
  null
  
)

export default component.exports